export const Networks = {
  // CRONOS = 25,
  // BSC = 56,
  CHAIN_ID: parseInt(process.env.REACT_APP_CHAIN_ID, 10),
};

export const DEFAULT_NETWORK = Networks.CHAIN_ID;
